// extracted by mini-css-extract-plugin
module.exports = {"editor":"mosaic-editor_editor__2g_SD","canvas":"mosaic-editor_canvas__3XIsB"};